const DEFAULT_RETURN_WINDOW_DAYS = 7;
const DAY_MS = 24 * 60 * 60 * 1000;

export const getReturnWindowDays = (book, country = 'IN') => {
  if (book?.returnable === false) return 0;
  const savedDays = String(country || 'IN').toUpperCase() === 'IN'
    ? book?.returnWindowDays
    : book?.internationalReturnWindowDays;
  if (savedDays == null || String(savedDays).trim() === '') return DEFAULT_RETURN_WINDOW_DAYS;
  const days = Number(savedDays);
  return Number.isInteger(days) && days >= 0 ? days : 0;
};

export const canReturnItem = (order, item, now = Date.now()) => {
  if (order.status !== 'Delivered' || !item.itemId || item.returnRequest) return false;
  const days = getReturnWindowDays(item, order.shippingCountry);
  const deliveredAt = order.deliveredAt ? new Date(order.deliveredAt).getTime() : NaN;
  return days > 0 && Number.isFinite(deliveredAt)
    && deliveredAt <= now && now - deliveredAt <= days * DAY_MS;
};
